import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as admin from '../../../admin'
import * as me from '../../../me'

import { Api } from './api.service'
import { ClipboardItem } from './clipboard-item'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'
/**
 * Collection of {@link Entity} (based on
 * {@link ents.core.mosaic.Widget})
 *
 * Used on developer's page to manage widgets
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link admin.editingVariables.Feature} */
  public readonly editingVariablesFeature = ngCore.inject(
    admin.editingVariables.Feature,
  )

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  constructor() {
    const meFeature = ngCore.inject(me.Feature)

    super({
      api: ngCore.inject(Api),
      context$: meFeature.contexts.selectors.zoneContext.asObservable,
      identify: widget => widget.id,
      name: ec.Name.Predefined.MosaicWidget,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory(collection => ({
            rowConfig: ({ entity: widget }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(`Table.Row-${widget.id}.Icons.Trash.Clicked`)
                      .dispatch({ id: widget.id })
                  },
                },
              ],
              onClick: () => {
                const source = `Table.Row-${widget.id}.Clicked`
                // Check if it already exists
                if (
                  collection.plugins.currentEntityPlugin.feature.selectors
                    .getEditedEntity()
                    .asSignal()
                ) {
                  // discard te current edit
                  collection.plugins.editingPlugin.feature.actions.discard
                    .from(source)
                    .dispatch({
                      current: true,
                    })
                }

                // start a new edit
                collection.plugins.editingPlugin.feature.actions.edit
                  .from(source)
                  .dispatch({ id: widget.id })
              },
            }),
          })),
          new plugins.preview.Factory(),
          new clipboard.Factory({
            clipboardService: ngCore.inject(clipboard.Service),
            pasteClassRef: ClipboardItem,
          }),
          new ds.input.select.singleEc.ec.Factory<TypeParams>({
            getItem: ({ name, alias }) => ({
              label: name,
              value: alias,
            }),
          }),
        ],
      },
    })

    this.feature.registerEffects(
      effects.syncWidgetVariablesForEditing(this),
      effects.triggerWidgetPreviewOnPageBuilderEdit(this),
      effects.widgetBuilderNavigate(this, meFeature, this._router),
    )
  }
}
